"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreState = void 0;
var StoreState;
(function (StoreState) {
    StoreState["OPEN"] = "OPEN";
    StoreState["OFF_HOUR"] = "OFF_HOUR";
    StoreState["SERVICE_PROVIDER_PAUSED"] = "SERVICE_PROVIDER_PAUSED";
    StoreState["OPERATOR_PAUSED"] = "OPERATOR_PAUSED";
    StoreState["SERVICE_PROVIDER_PAUSED_COURIERS_UNAVAILABLE"] = "SERVICE_PROVIDER_PAUSED_COURIERS_UNAVAILABLE";
    StoreState["STORE_UNAVAILABLE"] = "STORE_UNAVAILABLE";
    StoreState["HOLIDAY_HOUR"] = "HOLIDAY_HOUR";
    StoreState["MENU_UNAVAILABLE"] = "MENU_UNAVAILABLE";
    StoreState["SERVICE_PROVIDER_PAUSED_MISCONFIGURED"] = "SERVICE_PROVIDER_PAUSED_MISCONFIGURED";
    StoreState["OPEN_FOR_PICKUP_ONLY"] = "OPEN_FOR_PICKUP_ONLY";
    StoreState["OPEN_FOR_DELIVERY_ONLY"] = "OPEN_FOR_DELIVERY_ONLY";
    StoreState["CLOSED_FOR_UNDETERMINED_REASON"] = "CLOSED_FOR_UNDETERMINED_REASON";
})(StoreState = exports.StoreState || (exports.StoreState = {}));
